module.exports = __webpack_public_path__ + "img/colombia.8ea60931.svg";